@import "../../../helpers/helpers";

.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 0.1;
  background: black;
}

// Todo -- import typography.scss ?
.h1 {
  margin-bottom: 20px;
  text-transform: uppercase;

  @extend %sans-bold;
}

.fieldOptionList {
  margin: 20px 0;
  column-count: 2;
}

.fieldOption {
  margin: 0 0 6px;

  button {
    padding: 0;
    appearance: none;
    font-size: 16px;
    border: none;
    background: none;
    cursor: pointer;

    @extend %sans-bold;

    &:hover {
      opacity: 0.5;
    }
  }
}

.input {
  margin: 16px 0;
  padding: 7px;
  width: 100%;
  max-width: 540px;
  font-size: 16px;
  line-height: 1.4;
  @extend %serif;
}

.textarea {
  margin: 16px 0;
  padding: 7px;
  width: 100%;
  max-width: 540px;
  font-size: 16px;
  line-height: 1.4;
  @extend %serif;
}

.status {
  display: block;
  margin: 16px 0;
  padding: 7px;
  width: 100%;
  max-width: 540px;
  font-size: 16px;
  line-height: 1.4;
  width: 175px;
  text-transform: uppercase;
  @extend %sans-bold;
}

.policy {
  margin: 10px 0 28px;

  label {
    margin-right: 8px;
  }
}

.select {
  display: block;
  margin: 16px 0 24px;
  padding: 5px 28px 5px 7px;
  @extend %sans-serif;
  font-size: 16px;

  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 7px center;
  background-size: 16px;
}

.button {
  @extend %button;
  @extend %sans-bold;
  font-size: 16px;
  background-color: white;
  margin-right: 20px;
}

.confirm {
  margin: 10px 0 24px;
}
